// removed by extract-text-webpack-plugin
module.exports = {"App":"lBEXIWN5z0N5VPW0i1w00"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/App.css
// module id = 329
// module chunks = 0